import React from 'react';
import CommonConstants from '../../constants/CommonConstants';
import '../../css/submissionFields.css';
import Modal from 'react-modal';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Checkbox from '@material-ui/core/Checkbox';

export const JobConfirmationModal = (props) => {

    const handleChange = () => {
        props.setJobInfo(props.job);
        props.showModal(false);
    };

    return (
        <Modal
            isOpen={props.open}
            style={{
                content: {
                    top: '35%',
                    bottom: '40%',
                    left: '32.5%',
                    right: '32.5%',
                    padding: '1%'
                },
                overlay: {
                    backgroundColor: 'rgba(255, 255, 255, 0.5)'
                }
            }}
            ariaHideApp={false}>
            <div id='jobid-modal'>
                    This will auto-fill your submission form except design document.
                    Please upload your design document by clicking on edit icon given at the bottom
                <div style={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'space-around',
                        paddingTop: '4%'
                    }}>
                        <Button onClick={() => handleChange()} color="primary" variant="outlined">
                            OK
        </Button>
                        <Button onClick={() => props.showModal(false)} color="primary" variant="outlined">
                            Cancel
        </Button>
                    </div>
                </div>
        </Modal >

            )
        }
        
export const JobLoadingModal = (props) => {
    return (
        <Modal
                isOpen={props.isJobInfoLoading}
                style={{
                    content: {
                        top: '35%',
                        bottom: '52.5%',
                        left: '33.5%',
                        right: '33.5%',
                        padding: '1%',
                        display: 'flex',
                        alignItems: 'center'
                    },
                    overlay: {
                        backgroundColor: 'rgba(255, 255, 255, 0.5)'
                    }
                }}
                ariaHideApp={false}
            >
                <div id="loading-modal">
                    {CommonConstants.LOADING_MESSAGE}
                    <CircularProgress size={20} />
                </div>
            </Modal>
            )
        }
        
export const IsFavoriteModal = (props) => {
    return (
        <Modal open={props.open}>
                <div>
                    {CommonConstants.IS_FAVORITE_MESSAGE}
                    <Checkbox
                        color="primary"
                        checked={props.isFavorite}
                        onClick={(e) => {
                            props.handleChange("isFavorite", true);
                        }} />
                    <Checkbox
                        color="primary"
                        checked={!props.isFavorite}
                        onClick={(e) => {
                            props.handleChange("isFavorite", false);
                        }} />
                </div>
            </Modal>
            )
}